import { array, boolean, mixed, number, object, string } from 'yup';

import { core as appClientCore } from '@edf-pkg/app-client';

import { ROLE_IDS } from '$app-web/constants';
import client from '$app-web/core/client';

const requestSchema = object().shape({
    email: string().required(),
    password: string().required(),
    first_name: string().nullable().default(null),
    last_name: string().nullable().default(null),
    role_id: mixed().oneOf([ROLE_IDS.PARTICIPANT, ROLE_IDS.RESEARCHER]).required(),
    org_name: string(),
    client_id: string().required(),
});

const responseSchema = object().shape({
    device: object().shape({
        app_updated_at: number().nullable(),
        bt_mac: string().nullable(),
        cur_app_version: number().nullable(),
        cur_os_version: string().nullable(),
        date_created: number().nullable(),
        device_id: string().nullable(),
        last_app_version: number().nullable(),
        last_os_version: string().nullable(),
        last_used: number().nullable(),
        manufacturer: string().nullable(),
        model: string().nullable(),
        os_updated_at: number().nullable(),
        owner: number().nullable(),
        wifi_mac: string().nullable(),
    }),
    user: object().shape({
        username: string().required(),
        role_id: number().required(),
        id: number().required(),
        avatar: string().ensure(),
        first_name: string().ensure(),
        last_name: string().ensure(),
        language: string().ensure(),
        org_name: string().ensure(),
        is_email_verified: boolean().default(false),
        is_phone_verified: boolean().default(false),
        mfa_enabled: boolean().default(false),
        phone: string().ensure(),
        matrix_password: string().ensure(),
        subscription_configs: mixed().required(),
        preferred_notification_medium_ids: array().of(number()).required(),
        has_auto_logout: boolean().required().default(false),
        has_password_expiry: boolean().required().default(false),
        // TODO: Below fields are deprecate. Remove them after adjusting the UI in PDash.
        gender_id: number().required(),
        age_id: number().required(),
        education_id: number().required(),
        marital_status_id: number().required(),
        occupation_id: number().required(),
        salary_id: number().required(),
    }),
});

const useSignUpEndpoint = client.registerEndpoint('POST api/sign-up', 'v1/user/', {
    mutate: true,
    requestSchema,
    responseSchema,
    customErrorsOrMapper: {
        [appClientCore.ERROR_CODES.USER_EXIST]: (t) => t('pdash:signup_network_err_user_exits'),
    },
});

export default useSignUpEndpoint;
